import { useEffect } from 'react';

import CreatorApp from '@/pages/Creator';

import { useFeatureFlagsLoading } from './hooks/useFeatureFlags';
import { useOrgLoading } from './hooks/useOrg';
import { useUserLoading } from './hooks/useUser';
import { useSentryIdentify } from './utils/analytics/hooks';
import { enableSegment } from './utils/analytics/segment/singleton';

function AuthedApp() {
  const { loading: loadingUser } = useUserLoading();
  const { loading: loadingOrg } = useOrgLoading();
  const { loading: featureFlagsLoading } = useFeatureFlagsLoading();
  useSentryIdentify();

  useEffect(() => {
    enableSegment();
  }, []);

  if (loadingUser || loadingOrg || featureFlagsLoading) return null;

  return <CreatorApp />;
}

export default AuthedApp;
